import { Button, CardActions, Grid } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { navigate } from "gatsby";
import React, { useState } from "react";
import ActiveApplications from "../../core/config/activeApplications";
import ApplicationsDataGrid from "./applicationsDataGrid";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ajaxCall } from "../../core/services/ajaxService";

const applications = ActiveApplications;

type ExportTypes = "product" | "aggregate" | "all";

const Applications = () => {
  const [loadData, setLoadData] = useState(false);
  const [dataAlias, setDataAlias] = useState<string>("");
  const [apiUrl, setApiUrl] = useState<string>("");
  const [allowedExportTypes, setAllowedExportTypes] = useState<ExportTypes[]>(
    []
  );

  const handleSelect = (
    alias: string,
    apiUrl: string,
    allowedExportTypes: ExportTypes[]
  ) => {
    console.log(apiUrl);
    setLoadData(true);
    setDataAlias(alias);
    setApiUrl(apiUrl);
    setAllowedExportTypes(allowedExportTypes);
    console.log(alias);
  };

  const card = (info: any) => (
    <>
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Application name
        </Typography>
        <Typography variant="h5" component="div">
          {info.name}
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          version {info.version}
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          onClick={() =>
            handleSelect(info.alias, info.url, info.allowedExportTypes)
          }
        >
          Select
        </Button>
      </CardActions>
    </>
  );

  return (
    <>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        sx={{ py: 5 }}
      >
        {applications.map((el: any) => {
          return (
            <Grid item key={el.name} sm={3} md={3} lg={3} xl={1}>
              <Card variant="outlined" key={el.name}>
                {card(el)}
              </Card>
            </Grid>
          );
        })}

        <Grid
          justifyContent="center"
          alignItems="center"
          item
          key={dataAlias}
          md={12}
          mx={4}
        >
          {dataAlias.length > 0 && loadData ? (
            <>
              {allowedExportTypes.some((x) => x === "all") && (
                <Button
                  variant="contained"
                  href={`${apiUrl}api/Data/exportAll`}
                  endIcon={<FileDownloadIcon />}
                >
                  Download
                </Button>
              )}
              {allowedExportTypes.some((x) => x === "aggregate") && (
                <Button
                  variant="contained"
                  href={`${apiUrl}api/Data/exportAggregated`}
                  endIcon={<FileDownloadIcon />}
                >
                  Download Aggregate
                </Button>
              )}
              {allowedExportTypes.some((x) => x === "product") && (
                <Button
                  variant="contained"
                  href={`${apiUrl}api/Data/exportProduct`}
                  endIcon={<FileDownloadIcon />}
                >
                  Download Product
                </Button>
              )}

              <ApplicationsDataGrid key={dataAlias} alias={dataAlias} />
            </>
          ) : (
            <div> No Data to show!</div>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default Applications;
